import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { isNullOrUndefined } from '@as-react/common-utils';
import { MinusIcon } from '@yonderland/andes-icons';
import { Box, Icon, Stack, TextAlpha, TextField } from '@yonderland/andes-react';
export const FilterItemContentRangeFilterInputs = ({ value, onChange, min, max, filterPrefix, filterSuffix, }) => {
    var _a, _b;
    const MIN_DIFF_STEP = 1;
    const correctedValue = (val, minVal, maxVal) => {
        // Return value or min / max allowed value
        if (val < minVal) {
            return minVal;
        }
        if (val > maxVal) {
            return maxVal;
        }
        return val;
    };
    const handleChangeEnd = (name) => () => {
        if (isNullOrUndefined(value.max) || isNullOrUndefined(value.min)) {
            // let parent handle what to do when ending with undefined values
            onChange(value, true);
            return;
        }
        if (name === 'min') {
            onChange(Object.assign(Object.assign({}, value), { min: correctedValue(value.min, min, value.max - MIN_DIFF_STEP) }), true);
        }
        else {
            onChange(Object.assign(Object.assign({}, value), { max: correctedValue(value.max, value.min + MIN_DIFF_STEP, max) }), true);
        }
    };
    const handleKeyUp = (name) => (e) => {
        e.preventDefault();
        if (['Enter', 'Tab'].includes(e.key)) {
            handleChangeEnd(name)();
        }
    };
    const handleChange = (name) => (e) => {
        const roundFn = name === 'min' ? Math.floor : Math.ceil;
        const currentValue = e.currentTarget.value.replace(/[a-zA-Z]/g, '');
        onChange(Object.assign(Object.assign({}, value), { [name]: currentValue ? roundFn(Number(currentValue)) : undefined }));
    };
    return (_jsx(Box, { paddingBlockStart: { base: '4', md: '3' }, paddingBlockEnd: "4", children: _jsxs(Stack, { align: "center", gap: "3", children: [_jsx(TextField, { id: "filter-range-min", value: (_a = value.min) !== null && _a !== void 0 ? _a : '', type: "number", onChange: handleChange('min'), onKeyUp: handleKeyUp('min'), onBlur: handleChangeEnd('min'), min: min, max: max, inputMode: "numeric", adornmentStart: filterPrefix ? (_jsx(Box, { paddingInline: "2", display: "flex", children: _jsx(TextAlpha, { children: filterPrefix }) })) : null, adornmentEnd: filterSuffix ? (_jsx(Box, { paddingInline: "2", display: "flex", children: _jsx(TextAlpha, { children: filterSuffix }) })) : null }), _jsx(Icon, { size: "lg", source: MinusIcon }), _jsx(TextField, { id: "filter-range-max", value: (_b = value.max) !== null && _b !== void 0 ? _b : '', type: "number", onChange: handleChange('max'), onKeyUp: handleKeyUp('max'), onBlur: handleChangeEnd('max'), min: min, max: max, inputMode: "numeric", adornmentStart: filterPrefix ? (_jsx(Box, { paddingInline: "2", display: "flex", children: _jsx(TextAlpha, { children: filterPrefix }) })) : null, adornmentEnd: filterSuffix ? (_jsx(Box, { paddingInline: "2", display: "flex", children: _jsx(TextAlpha, { children: filterSuffix }) })) : null })] }) }));
};
